import z from 'zod/v4';
import moment from 'moment-timezone';
export var Timing;
(function (Timing) {
    Timing["Manual"] = "MANUAL";
    Timing["ASAP"] = "ASAP";
    Timing["OnCaseEnd"] = "ON_CASE_END";
    Timing["Quarterly"] = "QUARTERLY";
    Timing["Monthly"] = "MONTHLY";
    Timing["Weekly"] = "WEEKLY";
})(Timing || (Timing = {}));
export const BillingAppendixSchema = z.object({
    billingAppendixId: z.string(),
    seqId: z.number().optional(),
    handle: z.string(),
    onlyVoucherTypeIds: z.array(z.string()).optional().nullable(),
    timing: z.object({
        type: z.string(),
        details: z.object({}),
    }),
    hideFromCreditor: z.boolean(),
    includeVatInDepositShare: z.boolean(),
    createdAt: z.string().optional(),
    createdBy: z.any().optional(),
});
export const PatchBillingAppendixSetupSchema = z.object({
    name: z.string().optional(),
    appendices: z.array(BillingAppendixSchema).optional(),
});
export const CreateBillingAppendixSetupSchema = z.object({
    name: z.string(),
    appendices: z.array(z.object({
        billingAppendixId: z.uuid(),
        handle: z.string(),
        onlyVoucherTypeIds: z.array(z.uuid()).optional(),
        timing: z.object({
            type: z.enum(Timing),
            details: z.object({}).passthrough(),
        }),
        hideFromCreditor: z.boolean(),
        includeVatInDepositShare: z.boolean(),
    })),
});
export const addBillingAppendixToBillingVouchers = (billingAppendixSetup, newBillingVouchers, tenant) => {
    let newBillingVouchersToBeCreated = [];
    const newBillingVouchersToBeCreatedNotVat = newBillingVouchers.filter((billingVoucher) => !billingVoucher.vatOfBillingVoucherId);
    newBillingVouchersToBeCreated = newBillingVouchersToBeCreated.concat(newBillingVouchersToBeCreatedNotVat.map((newBillingVoucher) => setBillingAppendix(newBillingVoucher, billingAppendixSetup, tenant)));
    const newBillingVouchersToBeCreatedVat = newBillingVouchers.filter((billingVoucher) => billingVoucher.vatOfBillingVoucherId);
    newBillingVouchersToBeCreated = newBillingVouchersToBeCreated.concat(newBillingVouchersToBeCreatedVat.map((newBillingVoucher) => setBillingAppendixForVatVouchers(newBillingVoucher, billingAppendixSetup, newBillingVouchersToBeCreated, tenant)));
    return newBillingVouchersToBeCreated;
};
const setBillingAppendix = (billingVoucher, billingAppendixSetup, tenant) => {
    const billingAppendices = findBillingAppendices(billingVoucher, billingAppendixSetup);
    const billingAppendix = billingAppendices[0];
    if (billingAppendix) {
        billingVoucher.billingAppendixId = billingAppendix.billingAppendixId;
        billingVoucher.billAfter = getBillAfter(billingAppendix, billingVoucher, tenant);
    }
    return billingVoucher;
};
const setBillingAppendixForVatVouchers = (billingVoucher, billingAppendixSetup, billingVouchersNoVat, tenant) => {
    const vatOfVoucher = billingVouchersNoVat.find((_billingVoucher) => _billingVoucher.billingVoucherId === billingVoucher.vatOfBillingVoucherId);
    const billingAppendices = findBillingAppendices(billingVoucher, billingAppendixSetup);
    if (vatOfVoucher &&
        vatOfVoucher.billingAppendixId &&
        billingAppendices.find((appendix) => appendix.billingAppendixId === vatOfVoucher.billingAppendixId)) {
        billingVoucher.billingAppendixId = vatOfVoucher.billingAppendixId;
        billingVoucher.billAfter = vatOfVoucher.billAfter;
        return billingVoucher;
    }
    const billingAppendix = billingAppendices[0];
    if (billingAppendix) {
        billingVoucher.billingAppendixId = billingAppendix.billingAppendixId;
        billingVoucher.billAfter = getBillAfter(billingAppendix, billingVoucher, tenant);
    }
    return billingVoucher;
};
const findBillingAppendices = (billingVoucher, billingAppendixSetup) => {
    const appendices = billingAppendixSetup.appendices.filter((appendix) => {
        return appendix.onlyVoucherTypeIds
            ? appendix.onlyVoucherTypeIds.includes(billingVoucher.voucherTypeId)
            : true;
    });
    return appendices;
};
const getBillAfter = (billingAppendix, billingVoucher, tenant) => {
    switch (billingAppendix.timing.type) {
        case Timing.Weekly:
            return moment(billingVoucher.date)
                .tz(tenant.timezone)
                .endOf('week')
                .toISOString();
        case Timing.Monthly:
            return moment(billingVoucher.date)
                .tz(tenant.timezone)
                .endOf('month')
                .toISOString();
        case Timing.Quarterly:
            return moment(billingVoucher.date)
                .tz(tenant.timezone)
                .endOf('quarter')
                .toISOString();
        default:
            return null;
    }
};
//# sourceMappingURL=index.js.map